export default function AIPiggyBank({ className = '' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Piggy body */}
      <ellipse cx="100" cy="110" rx="70" ry="55" fill="url(#piggyGradient)" />

      {/* Piggy head */}
      <circle cx="100" cy="85" r="45" fill="url(#piggyGradient)" />

      {/* Ears */}
      <ellipse cx="65" cy="50" rx="12" ry="18" fill="url(#piggyGradient)" />
      <ellipse cx="135" cy="50" rx="12" ry="18" fill="url(#piggyGradient)" />
      <ellipse cx="65" cy="52" rx="6" ry="10" fill="#a855f7" opacity="0.5" />
      <ellipse cx="135" cy="52" rx="6" ry="10" fill="#a855f7" opacity="0.5" />

      {/* Snout */}
      <ellipse cx="100" cy="100" rx="20" ry="15" fill="#c084fc" />
      <circle cx="93" cy="98" r="4" fill="#1e1b4b" />
      <circle cx="107" cy="98" r="4" fill="#1e1b4b" />

      {/* Happy eyes */}
      <ellipse cx="80" cy="75" rx="8" ry="10" fill="white" />
      <ellipse cx="120" cy="75" rx="8" ry="10" fill="white" />
      <circle cx="82" cy="76" r="5" fill="#1e1b4b" />
      <circle cx="122" cy="76" r="5" fill="#1e1b4b" />
      <circle cx="84" cy="74" r="2" fill="white" />
      <circle cx="124" cy="74" r="2" fill="white" />

      {/* Smiling mouth */}
      <path
        d="M85 108 Q100 120 115 108"
        stroke="#1e1b4b"
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />

      {/* Rosy cheeks */}
      <circle cx="65" cy="90" r="8" fill="#f472b6" opacity="0.4" />
      <circle cx="135" cy="90" r="8" fill="#f472b6" opacity="0.4" />

      {/* Legs */}
      <ellipse cx="55" cy="155" rx="12" ry="15" fill="url(#piggyGradient)" />
      <ellipse cx="85" cy="158" rx="12" ry="15" fill="url(#piggyGradient)" />
      <ellipse cx="115" cy="158" rx="12" ry="15" fill="url(#piggyGradient)" />
      <ellipse cx="145" cy="155" rx="12" ry="15" fill="url(#piggyGradient)" />

      {/* Curly tail */}
      <path
        d="M170 110 Q185 100 180 115 Q175 130 185 125"
        stroke="url(#piggyGradient)"
        strokeWidth="8"
        strokeLinecap="round"
        fill="none"
      />

      {/* Coin slot */}
      <rect x="90" y="55" width="20" height="4" rx="2" fill="#1e1b4b" />

      {/* AI circuit patterns */}
      <circle cx="70" cy="120" r="3" fill="#22d3ee" opacity="0.8" />
      <circle cx="130" cy="120" r="3" fill="#22d3ee" opacity="0.8" />
      <circle cx="100" cy="140" r="3" fill="#22d3ee" opacity="0.8" />
      <path
        d="M70 120 L85 120 L85 130 L100 140"
        stroke="#22d3ee"
        strokeWidth="1.5"
        opacity="0.6"
      />
      <path
        d="M130 120 L115 120 L115 130 L100 140"
        stroke="#22d3ee"
        strokeWidth="1.5"
        opacity="0.6"
      />

      {/* Sparkles */}
      <path d="M45 40 L48 45 L45 50 L42 45 Z" fill="#fbbf24" />
      <path d="M160 35 L163 40 L160 45 L157 40 Z" fill="#fbbf24" />
      <path d="M175 80 L177 83 L175 86 L173 83 Z" fill="#fbbf24" />

      <defs>
        <linearGradient id="piggyGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#e879f9" />
          <stop offset="100%" stopColor="#a855f7" />
        </linearGradient>
      </defs>
    </svg>
  );
}
